module.exports = __webpack_public_path__ + "img/clinic.da39485a.svg";